module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Соглашение об использовании")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Для продолжения работы с системой Вам необходимо ознакомиться с правилами и подтвердить Ваше согласие на работу в соответствии с правилами\n            "), _c('div', [_c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.useRules)
    }
  }, [_vm._v("Лицензионное соглашение")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoRules)
    }
  }, [_vm._v("Политика обработки персональных данных")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoAgreement)
    }
  }, [_vm._v("Согласие на обработку персональных данных")])]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Даю согласие",
      "persistent-hint": "",
      "hint": "Политику обработки персональных данных изучил, Даю свое согласие на обработку моих персональных данных"
    },
    model: {
      value: (_vm.personAgreementCheck),
      callback: function($$v) {
        _vm.personAgreementCheck = $$v
      },
      expression: "personAgreementCheck"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.personAgreementCheck,
      "color": "primary"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Принять")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98c3c408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Agreement.vue
// module id = 988
// module chunks = 1